import { mcpQueryKeys } from '@/hooks/queries/use-mcp-query';
import api from '@/libs/axiosInstance';
import type { ApiResponse, McpConnectionActivityResponse } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';

/** What an assistant did on one connection; read only while its section is open. */
export function useConnectedAssistantActivityQuery(
  connectionId: string,
  { enabled }: { enabled: boolean }
) {
  return useQuery({
    queryKey: mcpQueryKeys.connectionActivity(connectionId),
    queryFn: async () => {
      const { data } = await api.get<ApiResponse<McpConnectionActivityResponse>>(
        `/account/connected-assistants/${connectionId}/activity`,
        { withCredentials: true }
      );
      if (!data.data) throw new Error('Missing assistant activity response');
      return data.data;
    },
    enabled,
    retry: false,
  });
}
